import { render } from "./MobileAccountSettings.vue?vue&type=template&id=1a28afaa&scoped=true"
import script from "./MobileAccountSettings.vue?vue&type=script&lang=js"
export * from "./MobileAccountSettings.vue?vue&type=script&lang=js"

import "./MobileAccountSettings.vue?vue&type=style&index=0&id=1a28afaa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a28afaa"],['__file',"src/views/mobile/account_center/components/MobileAccountSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a28afaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a28afaa', __exports__)) {
    api.reload('1a28afaa', __exports__)
  }
  
  module.hot.accept("./MobileAccountSettings.vue?vue&type=template&id=1a28afaa&scoped=true", () => {
    api.rerender('1a28afaa', render)
  })

}


export default __exports__